import { render, staticRenderFns } from "./SceneMaterialImage.vue?vue&type=template&id=16692376&scoped=true&"
import script from "./SceneMaterialImage.vue?vue&type=script&lang=js&"
export * from "./SceneMaterialImage.vue?vue&type=script&lang=js&"
import style0 from "./SceneMaterialImage.vue?vue&type=style&index=0&id=16692376&prod&scoped=true&lang=css&"
import style1 from "./SceneMaterialImage.vue?vue&type=style&index=1&id=16692376&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16692376",
  null
  
)

export default component.exports